"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibaryParser = void 0;
const spritesheet_parser_1 = require("./spritesheet.parser");
class LibaryParser {
    constructor() {
        this.priority = 10;
    }
    use(resource, loader) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = resource === null || resource === void 0 ? void 0 : resource.json) === null || _a === void 0 ? void 0 : _a.manifest) {
                resource.manifest = resource.json.manifest;
                if ('spritesheet' in resource.json) {
                    resource.spritesheet = yield spritesheet_parser_1.SpritesheetParser.fromJSON(resource.json.spritesheet, loader, resource);
                }
            }
        });
    }
}
exports.LibaryParser = LibaryParser;
